import QRCode from "qrcode";

/** Eigen token (gegenereerd door de server) of de inhoud van een bestaande sticker? */
export const isOwnToken = (code: string) => /^[A-Za-z0-9_-]{12}$/.test(code);

/** Wat in de QR-code staat: bij een eigen token de URL die de telefooncamera direct opent. */
export const qrContent = (code: string, origin = window.location.origin) =>
  isOwnToken(code) ? `${origin}/q/${code}` : code;

export interface QrMatrix {
  size: number;
  dark: (x: number, y: number) => boolean;
}

export function qrMatrix(text: string): QrMatrix {
  const q = QRCode.create(text, { errorCorrectionLevel: "M" });
  const { size, data } = q.modules;
  return { size, dark: (x, y) => Boolean(data[y * size + x]) };
}

/** Eén padstring (vierkantjes per donkere module), met rustzone van 4 modules. */
export function qrPath(m: QrMatrix, quiet = 4): string {
  let d = "";
  for (let y = 0; y < m.size; y++)
    for (let x = 0; x < m.size; x++) if (m.dark(x, y)) d += `M${x + quiet} ${y + quiet}h1v1h-1z`;
  return d;
}
